import globalSettingsStores from '../../../../../stores/settings-stores';
import React, { useState } from 'react';
import { Button } from 'primereact/button';
import { addPriceRateForLecturerOperations } from '../operations/add-price-rate-for-lecturer-operations';
import { Dropdown } from 'primereact/dropdown';
import { EditNumber } from '../../../../../component/ui/edit-text/edit-number';
import { LecturerRateDisplayType } from '../../../../../api/types/lecturers/price-rate/lecturer-rate-display-type';
import { UserSummaryType } from '../../../../../api/types/user/user-summary.type';
import globalConfigStore from '../../../../../stores/global-config-store';
import {
  PaymentType,
  SettingsLecturersRateType,
} from '../../../../../api/types/settings/lecturers/settings-lecturers-rate-type';
import globalSettingsBranches from '../../../../../stores/global-settings-branches';
import { SettingsBranches } from '../../../../../api/types/settings/branches/settings-branches';
import { Nullable } from 'primereact/ts-helpers';
import { Calendar } from 'primereact/calendar';
import { UserPageLecturerAddDoc } from './user-page-lecturer-add-doc';
import { FileUploadFile } from 'primereact/fileupload';
import { toast } from 'react-toastify';
import { EditText } from '../../../../../component/ui/edit-text/edit-text';
import { MultiSelect } from 'primereact/multiselect';
import { AbstractCourse } from '../../../../../api/types/settings/studies/abstract-course';
import { LegalEntityType } from './acountant/user-page-lecturer-rate-accountant';

interface UserPageLecturerPricesRateAddModel {
  user: UserSummaryType;
  onHide: () => any;
}

export const UserPageLecturerPricesRateAdd: React.FC<
  UserPageLecturerPricesRateAddModel
> = ({ user, onHide }) => {
  const [selectedPaymentServiceType, setSelectedPaymentServiceType] =
    useState<SettingsLecturersRateType | null>(null);

  const [selectedBranch, setSelectedBranch] = useState<SettingsBranches | null>(
    null,
  );
  const [selectedDisplayType, setSelectedDisplayType] =
    useState<LecturerRateDisplayType | null>(null);

  const [selectedAbstractCourses, setSelectedAbstractCourses] = useState<
    AbstractCourse[]
  >([]);

  const [selectedLegalEntityType, setSelectedLegalEntityType] =
    useState<LegalEntityType | null>(null);

  const [startDate, setStartDate] = useState<Nullable<Date>>(null);
  const [endDate, setEndDate] = useState<Nullable<Date>>(null);

  const [price, setPrice] = useState<number>(0);

  const [docName, setDocName] = useState('');
  const [docFile, setDocFile] = useState<FileUploadFile>();

  const [requestDescription, setRequestDescription] = useState('');
  const [travel, setTravel] = useState<number>();

  const [loading, setLoading] = useState(false);

  // Function to map enum values to user-friendly labels
  const getLabelFromEnum = (value: LecturerRateDisplayType): string => {
    switch (value) {
      case LecturerRateDisplayType.OneHour:
        return 'שעה שלמה';
      case LecturerRateDisplayType.AcademicHour:
        return 'שעה אקדמית (45 דק׳)';
      default:
        return value; // Return the value itself if no label is defined
    }
  };
  const rateDisplayTypeOptions = Object.keys(LecturerRateDisplayType).map(
    (key) => ({
      label: getLabelFromEnum(
        LecturerRateDisplayType[key as keyof typeof LecturerRateDisplayType],
      ), // Use a function to get a user-friendly label
      value:
        LecturerRateDisplayType[key as keyof typeof LecturerRateDisplayType],
    }),
  );

  const getRateTypeOptions = () => [
    { label: 'שכיר', value: LegalEntityType.EMPLOYEE },
    {
      label: 'עצמאי (מורשה)',
      value: LegalEntityType.VAT_REGISTERED_FREELANCER,
    },
    { label: 'עצמאי (פטור)', value: LegalEntityType.VAT_EXEMPT_FREELANCER },
    { label: 'חברה בע״מ', value: LegalEntityType.COMPANY },
    { label: 'עמותה', value: LegalEntityType.NONPROFIT },
  ];

  const onFeedbackSubmit = (
    userId: number,
    docId: number,
    value: string,
    file: FileUploadFile,
  ) => {
    setDocName(value);
    setDocFile(file);
  };

  const handleOnApprove = async () => {
    const abstractCourseIds = selectedAbstractCourses.map(
      (course) => course.id,
    );
    return addPriceRateForLecturerOperations(
      selectedBranch?.id ?? globalConfigStore.rootFilter.currentBranches?.id,
      user.id,
      selectedPaymentServiceType?.id,
      requestDescription,
      price,
      selectedDisplayType,
      startDate,
      endDate,
      docName,
      docFile,
      travel,
      abstractCourseIds,
      selectedLegalEntityType,
      onHide,
      setLoading,
    );
  };
  return (
    <div style={{ width: '350px' }}>
      <label style={{ fontSize: '14px', color: '#4b5563' }}>סוג שרות</label>
      <Dropdown
        style={{
          width: '100%',
          height: '40px',
          alignItems: 'center',
          marginTop: '4px',
          marginBottom: '8px',
        }}
        value={selectedPaymentServiceType}
        onChange={(e) => setSelectedPaymentServiceType(e.value)}
        options={globalSettingsStores.lecturersTypeRateNames}
        optionLabel="typeRateName"
        placeholder="בחר את סוג השרות"
        max={1}
      />

      <label style={{ fontSize: '14px', color: '#4b5563' }}>שלוחה</label>
      <Dropdown
        style={{
          width: '100%',
          height: '40px',
          alignItems: 'center',
          marginTop: '4px',
          marginBottom: '8px',
        }}
        value={selectedBranch}
        onChange={(e) => setSelectedBranch(e.value)}
        options={globalSettingsBranches.branches}
        optionLabel="branchName"
        placeholder="בחר את השלוחה המבוקשת"
        max={1}
      />

      <label style={{ fontSize: '14px', color: '#4b5563' }}>קורסים</label>
      <MultiSelect
        style={{
          width: '100%',
          alignItems: 'center',
          marginTop: '4px',
          marginBottom: '8px',
        }}
        value={selectedAbstractCourses}
        onChange={(e) => setSelectedAbstractCourses(e.value)}
        options={globalSettingsStores.abstractCourses}
        optionLabel="courseName"
        placeholder="בחר קורסים"
        display="chip"
        filter
      />

      <label style={{ fontSize: '14px', color: '#4b5563' }}>סוג יישות</label>
      <Dropdown
        style={{
          width: '100%',
          height: '40px',
          alignItems: 'center',
          marginTop: '4px',
          marginBottom: '8px',
        }}
        value={selectedLegalEntityType}
        onChange={(e) => setSelectedLegalEntityType(e.value)}
        options={getRateTypeOptions()}
        placeholder="בחר סוג יישות"
      />

      <div>
        <label style={{ fontSize: '14px', color: '#4b5563' }}>סוג תעריף</label>
        <Dropdown
          style={{
            width: '100%',
            height: '40px',
            alignItems: 'center',
            marginTop: '4px',
            marginBottom: '8px',
          }}
          value={selectedDisplayType}
          onChange={(e) => setSelectedDisplayType(e.value)}
          options={rateDisplayTypeOptions}
          optionLabel="label"
          placeholder="בחר את סוג התצוגה"
          max={1}
        />
      </div>
      {/*{selectedPaymentServiceType?.paymentType === PaymentType.Hourly && (
        <div>
          <label style={{ fontSize: '14px', color: '#4b5563' }}>
            סוג תעריף
          </label>
          <Dropdown
            style={{
              width: '100%',
              height: '40px',
              alignItems: 'center',
              marginTop: '4px',
              marginBottom: '8px',
            }}
            value={selectedDisplayType}
            onChange={(e) => setSelectedDisplayType(e.value)}
            options={rateDisplayTypeOptions}
            optionLabel="label"
            placeholder="בחר את סוג התצוגה"
            max={1}
          />
        </div>
      )}*/}
      <EditNumber title={'סכום'} onChange={setPrice} />

      <label style={{ fontSize: '14px', color: '#4b5563', marginTop: '16px' }}>
        תאריך התחלה
      </label>

      <Calendar
        style={{
          height: '40px',
          direction: 'ltr',
          width: '100%',
          marginTop: '4px',
          marginBottom: '16px',
          textAlign: 'right',
        }}
        inputStyle={{ textAlign: 'right' }}
        dateFormat="dd/mm/yy"
        value={startDate}
        onChange={(e) => setStartDate(e.value)}
        showIcon
      />

      <label style={{ fontSize: '14px', color: '#4b5563' }}>תאריך סיום</label>

      <Calendar
        style={{
          height: '40px',
          direction: 'ltr',
          width: '100%',
          marginTop: '4px',
          marginBottom: '16px',
        }}
        inputStyle={{ textAlign: 'right' }}
        dateFormat="dd/mm/yy"
        value={endDate}
        onChange={(e) => setEndDate(e.value)}
        minDate={startDate ?? undefined} // Sets minimum date to today
        showIcon
      />

      <label style={{ fontSize: '14px', color: '#4b5563', marginTop: '16px' }}>
        פירוט הבקשה (אופציונלי)
      </label>
      <EditText
        maxLength={100}
        onChange={(valueStr: string) => setRequestDescription(valueStr)}
      />

      <label style={{ fontSize: '14px', color: '#4b5563', marginTop: '16px' }}>
        תוספת נסיעות (אופציונלי)
      </label>
      <EditNumber
        maxLength={100}
        onChange={(valueStr: number) => setTravel(valueStr)}
      />

      <UserPageLecturerAddDoc user={user} onFeedbackSubmit={onFeedbackSubmit} />

      <div style={{ display: 'flex', justifyContent: 'center' }}>
        <Button
          onClick={handleOnApprove}
          loading={loading}
          style={{ height: '30px', marginTop: '8px' }}
          label={'אישור'}
        />
      </div>
    </div>
  );
};
